<template>
  <div class="index">
    <h1 class="title">佳驰科技简介</h1>
    <p class="sub-title">COMPANY PROFILE</p>
    <!-- <p class="profile-title">
      {{ detail.name }}
      <br />
      <span>{{ detail.ex_title }}</span>
    </p>-->
    <div class="profile">
      <!-- <video :src="detail.images" controls></video> -->
      <div class="img-box">
        <img src="../../assets/img/113.jpg" alt="" style="object-fit: cover" />
        <!-- <img src="../../assets/img/114.png" alt="" style="object-fit:cover;"> -->
      </div>
      <div class="right">
        <img src="../../assets/img/neck-bg.png" alt srcset />

        <p class="rich" v-html="detail.content"></p>
      </div>
    </div>
    <div class="history">
      <div></div>
    </div>
  </div>
</template>

<script>
import { gsjj } from '../../assets/js/api'
export default {
  data() {
    return {
      detail: {},
      intro:
        '成都佳驰电子科技有限公司成立于 2008 年，公司位于四川省成都市郫都区德源镇新经济产业园，占地 50 亩，建筑面积 40000 平米。旗下公司包括成都佳骋电子技术有限公司、深圳佳驰康电子科技有限公司等。公司专注于电磁辐射控制材料的设计、测试、分析及制造，产品广泛应用于军事、RFID、消费类电子、通讯基站等高技术领域。与国内数百家 500 强企业、科研院所及军工集团建立了长期友好合作关系。公司拥有国内领先、国际一流的技术实力，通过自主研发与创新、先后获得国家专利数十项，形成了具有自主知识产权的专利堡垒，2018 年荣获国家科技进步奖。公司属于国家高新技术企业、成都市成长型创新型企业、成都市企业技术中心，也是“国家电磁辐射控制材料工程技术研究中心”成果转化基地，是“产学研”合作的典范。公司致力于引领及推动电磁功能材料新技术与结构的不断发展，通过全面参与国际竞争，更好的满足市场及客户的需求，服务行业及社会！',
    }
  },
  created() {
    gsjj().then((r) => {
      this.detail = r.data
    })
  },
}
</script>

<style lang="less" scoped>
.profile-title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(19, 112, 204, 1);
  line-height: 32px;
  padding-left: calc(100% - 910px + 80px + 24px);
  box-sizing: border-box;

  span {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(19, 112, 204, 1);
    display: inline-block;
  }
}
.index {
  padding-top: 90px;
  box-sizing: border-box;

  & > .title {
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: black;
    text-align: center;
  }

  & > .sub-title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    color: #cccccc;
    text-align: center;
    margin-bottom: 60px;
  }

  .profile {
    margin-bottom: 90px;
    display: flex;
    align-items: center;
    & > video,
    .img-box {
      width: calc(100% - 910px);

      & > img {
        width: 100%;
        height:610px;
        object-fit: cover;
      }
    }

    .right {
      width: calc(722px + 108px + 80px);
    //   padding-top: 30px;
      box-sizing: border-box;
      position: relative;
      padding-left: 80px;
      padding-right: 108px;

      & > img {
        width: 121px;
        height: 134px;
        position: absolute;
        top: 10px;
        left: 38px;
      }

      .title {
      }

      .rich {
        // margin-top: 30px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 24px;
      }
    }
  }
}
</style>
